import {
  ICreatePartnerExclusionParams,
  partnerExclusionApi,
} from 'onboarding/api/partnerExclusionApi'
import { TPartnerExclusionToSave } from 'onboarding/classes/models/partnerExclusion'
import { TListParams } from 'onboarding/types/crud'

class PartnerExclusionService {
  public fetchList(params: TListParams) {
    return partnerExclusionApi.fetchList(params)
  }

  public fetchOneFull(uid: string) {
    return partnerExclusionApi.fetchOneFull(uid)
  }

  public deleteOne(uid: string) {
    return partnerExclusionApi.deleteOne(uid)
  }

  public createOne(params: ICreatePartnerExclusionParams, accessToken: string) {
    return partnerExclusionApi.createOne(params, accessToken)
  }

  public updateOne(uid: string, payload: TPartnerExclusionToSave) {
    return partnerExclusionApi.updateOne(uid, payload)
  }

  public downloadExclusionFiles(uid: string, archiveName: string, accessToken: string) {
    return partnerExclusionApi.downloadExclusionFiles(uid, archiveName, accessToken)
  }

  public exportAll(accessToken: string, params: Pick<TListParams, 'filter' | 'sort'>) {
    return partnerExclusionApi.exportAll(accessToken, params)
  }

  public getListCrud(cacheKey?: string) {
    return partnerExclusionApi.getListCrud(cacheKey)
  }
}

export const partnerExclusionService = new PartnerExclusionService()
